import styled from 'styled-components'
import theme from 'styles/theme'

export type LogoSize = '24px' | '32px' | '64px'
export type IconSize = '24px' | '32px'

interface LogoCSSProps {
  $size: LogoSize
}

interface MarginRightProp {
  /**
   * @deprecated
   *
   * This Property should be removed from this components
   * Wrappers around it should add the needed margin in order
   * to make the design requirements
   */
  $addRightMargin?: boolean
}

const WRAPPER_BORDER_RADIUS: Record<LogoSize, string> = {
  '24px': theme.radii.base,
  '32px': theme.radii.medium,
  '64px': theme.radii.xlarge,
} as const

const WRAPPER_BOX_SHADOW: Record<LogoSize, string> = {
  '24px': 'none',
  '32px': '0 1px 2px 0 rgba(0,0,0,0.15)',
  '64px': 'none',
}

const LETTER_SIZE: Record<LogoSize, string> = {
  '24px': '0.6875rem', // 11px
  '32px': theme.fontSizes.xlarge, // 24px
  '64px': theme.fontSizes.xlarge, // 24px
}

const ICON_SIZE: Record<IconSize, string> = {
  '24px': '16px',
  '32px': '18px',
}

export const Wrapper = styled.div.attrs({
  'data-testid': 'workspace-logo',
})<LogoCSSProps & MarginRightProp>`
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};

  overflow: hidden;
  box-shadow: ${({ $size }) => WRAPPER_BOX_SHADOW[$size]};
  border-radius: ${({ $size }) => WRAPPER_BORDER_RADIUS[$size]};
  flex-shrink: 0;
  user-select: none;

  background-color: ${({ theme }) => theme.colors.background.light.base};
  margin-right: ${({ $addRightMargin }) => ($addRightMargin ? '12px' : '0')};

  ::after {
    border-radius: ${({ $size }) => WRAPPER_BORDER_RADIUS[$size]};
    content: '';
    position: absolute;
    border: 1px solid ${({ theme }) => theme.colors.border.dark.high};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  color: transparent;
`

interface IconWrapperProps {
  $size: IconSize
}

export const IconWrapper = styled.div<IconWrapperProps>`
  line-height: 1;

  width: ${({ $size }) => ICON_SIZE[$size]};
  height: ${({ $size }) => ICON_SIZE[$size]};
`

export const FirstLetter = styled.span<LogoCSSProps>`
  display: block;

  font-size: 0;
  text-transform: uppercase;
  text-align: center;
  color: ${({ theme }) => theme.colors.foreground.secondary[2]};

  ::before {
    content: attr(data-name);
  }

  ::first-letter {
    line-height: 1;
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    font-size: ${({ $size }) => LETTER_SIZE[$size]};
  }
`
